import { SaleSelectableEntitiesResponseDto } from "@/lib/interfaces/sales";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui-components/ui/select";
import { Dispatch, SetStateAction, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

interface SalesFiltersProps {
  selectableEntities: SaleSelectableEntitiesResponseDto;
  setFilters: Dispatch<SetStateAction<string[]>>;
}

const SalesFilters = ({ selectableEntities, setFilters }: SalesFiltersProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleUserChange = (value: string) => {
    setFilters((prev) => {
      const newFilters = prev.filter((filter) => !filter.startsWith("belongsToUserId="));
      if (value !== "undefined") {
        newFilters.push(`belongsToUserId=${value}`);
        setSearchParams((prev) => {
          prev.set("belongsToUserId", value);
          return prev;
        });
      } else {
        setSearchParams((prev) => {
          prev.delete("belongsToUserId");
          return prev;
        });
      }
      return newFilters;
    });
  };

  const handleStatusChange = (value: string) => {
    setFilters((prev) => {
      const newFilters = prev.filter((filter) => !filter.startsWith("state="));
      if (value !== "undefined") {
        newFilters.push(`state=${value}`);
        setSearchParams((prev) => {
          prev.set("state", value);
          return prev;
        });
      } else {
        setSearchParams((prev) => {
          prev.delete("state");
          return prev;
        });
      }
      return newFilters;
    });
  };

  useEffect(() => {
    const belongsToUserId = searchParams.get("belongsToUserId");
    const status = searchParams.get("state");
    if (belongsToUserId) {
      handleUserChange(belongsToUserId);
    }
    if (status) {
      handleStatusChange(status);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex gap-4 items-center">
      <Select onValueChange={handleUserChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Person auswählen" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="undefined">Alle</SelectItem>
          {selectableEntities.users.map((user) => (
            <SelectItem key={user._id} value={user._id}>
              <div className="flex flex-col">
                <span>{user.value}</span>
                <span className="text-xs text-gray-500">{user.salesRankTitle}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select onValueChange={handleStatusChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Status auswählen" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="undefined">Alle</SelectItem>
          <SelectItem value="OPEN">Offen</SelectItem>
          <SelectItem value="DRAFT">Entwurf</SelectItem>
          <SelectItem value="COMPLETED">Gebucht</SelectItem>
          <SelectItem value="CANCELLED">Storniert</SelectItem>
          <SelectItem value="CLOSED">Geschlossen</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default SalesFilters;
